/**
 * Rewrite deprecated `blog.marginwiz.com` URLs to the current marketing blog on `www.marginwiz.com`.
 * Used when rendering Portable Text links from Sanity.
 */
export function normalize_marketing_external_href(href: string): string {
  if (!href || href === "#") {
    return href
  }
  try {
    const u = new URL(href, "https://www.marginwiz.com")
    if (u.hostname !== "blog.marginwiz.com") {
      return href
    }
    const path = u.pathname.replace(/\/$/, "") || ""
    const slugPath = path.replace(/^\//, "")
    const newPath = slugPath === "" ? "/blog" : `/blog/${slugPath}`
    return `https://www.marginwiz.com${newPath}${u.search}${u.hash}`
  } catch {
    return href
  }
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("normalize_marketing_external_href", () => {
    it("rewrites blog subdomain root to /blog", () => {
      expect(normalize_marketing_external_href("https://blog.marginwiz.com/")).toBe("https://www.marginwiz.com/blog")
    })

    it("rewrites post path under /blog/", () => {
      expect(normalize_marketing_external_href("https://blog.marginwiz.com/my-post")).toBe(
        "https://www.marginwiz.com/blog/my-post",
      )
    })

    it("leaves other URLs unchanged", () => {
      expect(normalize_marketing_external_href("https://www.marginwiz.com/blog/foo")).toBe(
        "https://www.marginwiz.com/blog/foo",
      )
    })
  })
}
